module.exports = __webpack_public_path__ + "static/img/big-5.ed8253d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-5.png
// module id = sjpA
// module chunks = 64